import { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

export function useSidebarDrawer(bodyClass: string) {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  const close = useCallback(() => setIsOpen(false), []);
  const toggle = useCallback(() => setIsOpen((open) => !open), []);

  useEffect(() => {
    close();
  }, [location.pathname, close]);

  useEffect(() => {
    if (!isOpen) return;

    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') close();
    };

    document.addEventListener('keydown', onKeyDown);
    document.body.style.overflow = 'hidden';

    return () => {
      document.removeEventListener('keydown', onKeyDown);
      document.body.style.overflow = '';
    };
  }, [isOpen, close]);

  useEffect(() => {
    document.body.classList.toggle(bodyClass, isOpen);
    return () => document.body.classList.remove(bodyClass);
  }, [isOpen, bodyClass]);

  return { isOpen, close, toggle };
}
